"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionReducer = exports.DEFAULT_WIDGET_PERMISSION = void 0;
const core_1 = require("../../../core");
const constant_1 = require("../../constant");
exports.DEFAULT_WIDGET_PERMISSION = {
    storage: {
        editable: false
    },
    datasheet: core_1.DEFAULT_PERMISSION
};
function permissionReducer(state = exports.DEFAULT_WIDGET_PERMISSION, action) {
    switch (action.type) {
        case constant_1.SET_PERMISSION: {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        default: return state;
    }
}
exports.permissionReducer = permissionReducer;
